export default __webpack_public_path__ + "static/media/1158.e592a640.png";